import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" {...props}>
      <path
        d="M16.1224 30.2174C23.4557 30.2174 29.4557 24.2174 29.4557 16.8841C29.4557 9.55078 23.4557 3.55078 16.1224 3.55078C8.78906 3.55078 2.78906 9.55078 2.78906 16.8841C2.78906 24.2174 8.78906 30.2174 16.1224 30.2174Z"
        fill="#DC1F4E"
        fill-opacity="0.12"
        stroke="#DC1F4E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3516 20.656L19.8982 13.1094"
        stroke="#DC1F4E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.8982 20.656L12.3516 13.1094"
        stroke="#DC1F4E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Svg>
  );
};

export default Icon;
